<template>
    <div>
        <b-modal
            :id="modalId"
            ref="creditConvertForm"
            title-tag="h2"
            :title="`Refund to Card, ` + credit.name"
            :lazy="true"
            ok-title="Save"
            @ok="save()"
            :ok-disabled="isOkDisabled"
            footer-class="d-flex justify-content-between"
        >
            <form name="convert-form">
                <b-form-group label-for="date" label="Amount:" label-cols="4">
                    <div class="p-2">
                        {{ credit.balance ? _toCurrency(credit.balance) : 0.0 }}
                    </div>
                </b-form-group>

                <b-form-group label-for="date" label="Date:" label-cols="4">
                    <date-picker
                        :config="datePickerOptions"
                        v-model="currentDate"
                        v-validate="'required'"
                        class="form-control"
                        placeholder="Date (required)"
                        name="date"
                    ></date-picker>
                </b-form-group>

                <b-form-group label-for="note" label="Notes:" label-cols="4">
                    <b-form-textarea
                        v-model="editNote"
                        placeholder="Notes (optional)"
                        rows="3"
                        name="note"
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template v-slot:modal-footer="{ cancel, close }">
                <modal-footer
                    :is-loading="isLoading"
                    ok-title="Save"
                    @ok-action="save(close)"
                    @cancel-action="cancel"
                />
            </template>
        </b-modal>
    </div>
</template>
<script type="text/javascript">
import moment from "moment";
import PaymentDialogHelper from "@/module/payment/helper.js";
import BillingCreditServices from "@/services/billing/billing-credit";

export default {
    mixins: [PaymentDialogHelper],
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalId: {
            type: String,
            required: true
        },
        credit: {
            type: Object,
            default() {
                return { id: null };
            }
        }
    },
    computed: {
        isOkDisabled() {
            return this.currentDate == null;
        }
    },
    data() {
        return {
            currentDate: null,
            editNote: null,
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            isLoading: false
        };
    },
    mounted() {
        this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
            if (modalId == this.modalId) {
                this.init();
            }
        });
    },
    methods: {
        init() {
            this.datePickerOptions.format = this.getDateFormat();
            this.currentDate = moment().tz(this._timeZone);
            this.editNote = _.clone(this.credit.note);
        },
        save(close) {
            this.isLoading = true;

            let params = {
                credit_id: this.credit.id,
                date: this._fromDateStrToDateTime(this.currentDate, true),
                note: this.editNote
            };

            BillingCreditServices.refundToCard(params)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.message || response.messages);
                        this.$emit("reload");
                        close();
                    } else {
                        this._message(
                            response.message || response.messages,
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to refund credit", "danger");
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>
